<template>
<div :class="{
    'input-group': hasInputGroup,
    'position-relative': icon,
}">
    <input type="text" 
        ref="dateInput"
        class="form-control"
        :class="{ 'pe-5': icon }"
        :placeholder="placeholder" />
    <i v-if="icon" class="ri-calendar-line ri-lg position-absolute top-50 end-0 translate-middle-y me-3 pe-none"></i>
    <span class="input-group-btn" v-if="hasInputGroup">
        <button class="btn btn-default" @click="resetDatePicker">
            <i class="glyphicon glyphicon-remove"></i>
        </button>
    </span>
</div>
</template>

<script>
export default {
    props: {
        settings: {
            type: Object,
            required: true,
        },
        enableReset: {
            type: Boolean,
            required: false,
            default: false,
        },
        icon: {
            type: Boolean,
            required: false,
            default: false,
        },
        placeholder: {
            type: String,
            required: false,
            default: '',
        },
    },
    data: () => ({
        picker: null,
    }),
    computed: {
        hasInputGroup() {
            // multiple things in the future might affect this
            return this.enableReset;
        },
    },
    watch: {
        settings: {
            deep: true,
            immediate: true,
            handler(val) {
                let startDate = null
                let endDate = null
                
                if (val?.startDate) {
                    startDate = moment(val?.startDate)
                }

                if (val?.endDate) {
                    endDate = moment(val?.endDate)
                }
                // meets minimum requirement
                if (startDate) {
                    this.setDate(startDate, endDate)
                }
            },
        }
    },
    methods: {
        getDate() {
            const { startDate, endDate } = this.picker
            
            return { startDate, endDate }
        },
        setDate(startDate, endDate = null) {            
            if (!this.picker) return;

            this.picker.setStartDate(startDate)
            this.picker.setEndDate(endDate || startDate)
        },
        resetDatePicker() {
            const { dateInput } = this.$refs

            dateInput.value = ''

            this.$emit('change', null)
        },
        init() {
            const { daterangepicker } = window.wisenetwork
            const { dateInput } = this.$refs
            const { settings } = this
            const defaultSettings = {
                locale: { 
                    format: 'DD.MM.YYYY',
                    daysOfWeek: _localeDates.dayNamesMin,
                    monthNames: _localeDates.monthNamesShort,
                    firstDay: 1,
                },
            }
            let { startDate, endDate } = settings

            if (typeof startDate === 'string' && startDate.length > 0) {
                startDate = moment(startDate)
            }

            if (typeof endDate === 'string' && endDate.length > 0) {
                endDate = moment(endDate)
            }
            
            this.picker = daterangepicker(
                dateInput,
                {
                    ...defaultSettings,
                    ...settings,
                    startDate: startDate || moment(),
                    endDate: endDate, // no default
                }, 
                (startDate, endDate) => { // This is NOT called when user selects the date of today, if startDate is moment() without a parameter, i.e. if <wn-date-picker> was initiated with a falsy startDate.
                    this.$emit('change', { startDate, endDate })
                }
            )
            dateInput.addEventListener('apply.daterangepicker', (event) => { // This is called even if daterangepicker thinks the selected date did not change.
                const picker = event.detail
                this.$emit('change', {startDate: picker.startDate, endDate: picker.endDate}); // Emit the same event as the normal change would do.
            })

            if (!startDate) {
                this.$nextTick(() => this.resetDatePicker())
            }
        },
    },
    mounted() {
        this.init()
    },
}
</script>